import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(VueRouter);

function requireAuth(to, from, next) {
    if (store.getters['auth/isLoggedIn']) {
        next();
    } else {
        store.commit('auth/setAuthRedirect', to.fullPath);
        next({
            path: '/login'
        });
    }
}

const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            beforeEnter: requireAuth
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
        },
        {
            path: '/store/new',
            name: 'storeNew',
            component: () => import(/* webpackChunkName: "storeNew" */ './views/StoreNew.vue'),
            beforeEnter: requireAuth
        },
        {
            path: '/store/:id',
            name: 'store',
            component: () => import(/* webpackChunkName: "store" */ './views/Store.vue'),
            beforeEnter: requireAuth
        },
        {
            path: '/store/:id/sales_item/new',
            name: 'salesItemNew',
            component: () => import(/* webpackChunkName: "salesItemNew" */ './views/SalesItemNew.vue'),
            beforeEnter: requireAuth
        },
        {
            path: '/store/:store_id/sales_item/edit/:id',
            name: 'salesItemEdit',
            component: () => import(/* webpackChunkName: "salesItemEdit" */ './views/SalesItemEdit.vue'),
            beforeEnter: requireAuth
        },
        {
            path: '/store/:store_id/sales_item/:id',
            name: 'salesItem',
            component: () => import(/* webpackChunkName: "salesItem" */ './views/SalesItem.vue'),
            beforeEnter: requireAuth
        },
        {
            path: '/store/:store_id/order/:id',
            name: 'order',
            component: () => import(/* webpackChunkName: "salesItem" */ './views/Order.vue'),
            beforeEnter: requireAuth
        }
    ]
});

export default router;
